module.exports = __webpack_public_path__ + "img/netherland.047d0f45.svg";